<template>
    <div>
        <div
            :aria-checked="!!model"
            :aria-disabled="disabled"
            :class="{
                'np-outer-switch-on': model,
                'np-outer-switch-off': !model,
            }"
            class="np-outer-switch w-13 h-8 bg-gray-300 cursor-pointer relative rounded-2xl shadow-sm"
            role="switch"
            @click="toggleSwitch"
        >
            <div
                :class="{
                    'np-inner-switch-left': !model,
                    'np-inner-switch-right': model,
                }"
                class="w-6 h-6 bg-white rounded-full absolute top-1 left-[0.3rem]"
            >
                <svg
                    class="w-3 h-auto absolute top-2 left-1.5"
                    fill="none"
                    viewBox="0 0 12 9"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.72667 7.05333L0.946667 4.27333L0 5.21333L3.72667 8.94L11.7267 0.94L10.7867 0L3.72667 7.05333Z"
                        fill="#21005D"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const model = defineModel<boolean | null>({ default: null });

const props = withDefaults(
    defineProps<{
        disabled?: boolean;
    }>(),
    {
        disabled: false,
    },
);

const toggleSwitch = () => {
    if (props.disabled) {
        return;
    }

    model.value = !model.value;
};
</script>

<style scoped>
@reference "../../assets/css/app.css";

.np-outer-switch[aria-disabled="true"] {
    @apply bg-gray-500 cursor-not-allowed;
}

.np-outer-switch-off {
    @apply bg-gray-200 transition-colors duration-300;
}

.np-outer-switch[aria-disabled="false"].np-outer-switch-off:hover {
    @apply bg-gray-300;
}

.np-outer-switch-on {
    @apply bg-black transition-colors duration-300;
}

.np-outer-switch[aria-disabled="false"].np-outer-switch-on:hover {
    @apply bg-gray-800;
}

.np-inner-switch-left {
    @apply transition-all duration-300 top-1 left-1;
}

.np-inner-switch-left svg {
    @apply opacity-0;
}

.np-inner-switch-right {
    @apply transition-all duration-300 top-1 left-6;
}

.np-inner-switch-right svg {
    @apply opacity-100;
}
</style>
